import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardDescription,
} from "../../../components/ui/card";
import { Separator } from "../../../components/ui/separator";
import { DataTable } from "./PrescriptionTable/DataTable";
import { columns } from "./PrescriptionTable/columns";
import BrandNamePrescription from "./BrandNamePrescription";
import { getPrescriptionAppointmentByAppointmentId } from "../../../services/prescriptionAppointmentService";
import { PrescriptionType } from "../../../utils/global-types";
import { patientBasicInfoType } from "../Profile/PatientTypes";
import { z } from "zod";
import { PatientMedicalInfoSchema } from "../MedicalProfile/PatientMedicalProfileForm";
import { useAuth } from "../../../hooks/useAuth";
import { checkUserHasRole } from "../../../utils/auth-utils";
import { ROLES } from "../../../config/roles";
import { SingleLinePrescription } from "./SingleLinePrescription";

export function PatientPrescription({
  appointmentId,
  patientBasicInfoState,
  patientMedicalInfoState,
}: {
  appointmentId: string | undefined;
  patientBasicInfoState: patientBasicInfoType;
  patientMedicalInfoState: z.infer<typeof PatientMedicalInfoSchema>;
}) {
  const { roles } = useAuth();
  const [prescriptionData, setPrescriptionData] = useState<PrescriptionType[]>(
    []
  );
  const [loading, setLoading] = useState(false);

  function getPrescriptionData(appointmentId: string) {
    setLoading(true);
    getPrescriptionAppointmentByAppointmentId(appointmentId)
      .then((data) => {
        setPrescriptionData(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    if (appointmentId) {
      getPrescriptionData(appointmentId);
    }
  }, [appointmentId]);

  return (
    <Card className="w-full">
      <CardHeader className="text-left">
        <CardTitle>Prescriptions</CardTitle>
        <CardDescription>
          Medications prescribed for this appointment.
        </CardDescription>
      </CardHeader>
      <CardContent className="  justify-center grid grid-rows-2 gap-2 my-0">
        {checkUserHasRole([ROLES.PRESCRIPTION_TABLE_VIEW_ROLE], roles ?? []) ? (
          <DataTable
            columns={columns({ getPrescriptionData })}
            data={prescriptionData}
            loading={loading}
            patientBasicInfoState={patientBasicInfoState}
            patientMedicalInfoState={patientMedicalInfoState}
          />
        ) : null}
        {checkUserHasRole([ROLES.PRESCRIPTION_ADD_ROLE], roles ?? []) ? (
          <SingleLinePrescription
            appointmentId={appointmentId}
            getPrescriptionData={getPrescriptionData}
          />
        ) : null}
      </CardContent>
    </Card>
  );
}
